<template>
    <v-expansion-panel-header class="shaded-light">
        <div class="content-wrapper">
            <div class="left-content">
                <div
                    class="step-number-badge mt-1 mr-3"
                    :class="{ 'complete': complete, 'time-sensitive': !complete && is_time_sensitive }"
                >
                    {{ step_number }}
                </div>

                <strong
                    class="panel-header-label"
                    :class="{ 'error--text': !complete && is_time_sensitive, 'success--text': complete }"
                >
                    {{ label }}
                </strong>
            </div>

            <div class="right-content">
                <span
                    v-if="!complete && is_time_sensitive"
                    class="mr-4"
                >
                    <v-chip
                        color="error"
                        small
                        outlined
                    >
                        <v-icon
                            left
                            size="18"
                            aria-hidden="true"
                        >
                            mdi-clock-time-eight-outline
                        </v-icon>
                        <strong>Time-Sensitive</strong>
                    </v-chip>
                </span>

                <div>
                    <slot name="status_chip" />

                    <v-icon
                        v-if="complete && !$slots.status_chip"
                        class="mr-4"
                        size="24"
                        color="success"
                        :aria-label="'Step ' + step_number + ' complete'"
                    >
                        mdi-check-circle
                    </v-icon>
                </div>

            </div>
        </div>
    </v-expansion-panel-header>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: function () { return 'Title'; }
        },

        complete: {
            type: Boolean,
            default: function () { return false; }
        },

        is_time_sensitive: {
            type: Boolean,
            default: function () { return false; }
        },

        step_number: {
            type: Number,
            default: function () { return 1; }
        },
    },
}
</script>

<style lang="scss" scoped>
.content-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    font-size: 1.2rem;
}

.left-content {
    display: flex;
    align-items: center;
}

.right-content {
    display: flex;
    align-items: center;
}

.step-number-badge {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    border: 2px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 0.875rem;
    color: white;
    background-color: #666;
    flex-shrink: 0;

    &.complete {
        background-color: var(--v-success-base, #4caf50);
    }

    &.time-sensitive {
        background-color: var(--v-error-base, #f44336);
    }
}

.panel-header-label {
    position: relative;
    top: 2px;
}
</style>